
export default {
    AppActiveUser: {id: 0, first_name: '', second_name: '', email: ''},
}
